export const distanceOptions = [
  { value: '5 miles', label: '5 miles' },
  { value: '10 miles', label: '10 miles' },
  { value: '25 miles', label: '25 miles' },
  { value: '50 miles', label: '50 miles' },
  { value: '100 miles', label: '100 miles' },
  { value: '150 miles', label: '150 miles' },
  { value: '200 miles', label: '200 miles' },
  { value: '10000 miles', label: 'Any miles' },
]

export const DEFAULT_DISTANCE = '25 miles'
